import React from "react";
import { Helmet } from 'react-helmet';
import CardsInfo from "./inc/CardsInfo";
import CallDataFetch from "./inc/CallDataFetch";
import CallDataAxios from "./inc/CallDataAxios";


function AboutUs(){


  
return (

<div>

<Helmet>
        <title>سیستم یکپارچه مالی راینو - درباره ما</title>
        <meta name="description" content="ما کی هستیم و چه خدماتی ارائه می‌دهیم. آشنایی با تیم ما و ماموریت‌مان." />
        <meta name="keywords" content="درباره ما, تیم, خدمات, ماموریت , راینو" />
</Helmet>


<section className="py-4 bg-light title">

   <div className="container">
     <div className="row">
        <div className="col-md-6 my-auto">
        <h3 className="float-end"> معرفی شرکت فنی مهندسی پویارایانه فرتاک</h3>
        </div>

      </div>
     </div>

</section>




<section className="section border-bottom">
  <div className="container">
  <p>
  شرکت فنی مهندسی پویارایانه فرتاک با بیش از 20 سال تجربه در زمینه توسعه نرم‌افزارهای مالی و اتوماسیون بیمارستانی، به عنوان یکی از پیشگامان این صنعت شناخته می‌شود. ما با بهره‌گیری از فناوری‌های نوین و تیمی مجرب، به ارائه راه‌حل‌های نرم‌افزاری متناسب با نیازهای خاص مشتریان خود پرداخته‌ایم.

هدف ما ارتقاء کیفیت خدمات مالی و بهبود فرآیندهای بیمارستانی است. نرم‌افزارهای ما به کسب‌وکارها و مراکز درمانی کمک می‌کند تا با استفاده از ابزارهای هوشمند و کارآمد، مدیریت مالی و عملیاتی خود را بهینه‌سازی کنند. ما متعهد به ارائه راه‌حل‌های سفارشی و با کیفیت هستیم که همواره پاسخگوی نیازهای متغیر مشتریان باشد.

در راینو سیستم آسیا، ما به یادگیری مداوم و نوآوری اعتقاد داریم و به همین دلیل، همواره در تلاش هستیم تا محصولات و خدمات خود را با آخرین دستاوردهای فناوری هماهنگ کنیم. با توجه به سابقه طولانی و تجربه‌مان در این حوزه، ما توانسته‌ایم اعتماد بسیاری از سازمان‌ها و مراکز درمانی را جلب کنیم و به عنوان یک شریک قابل اعتماد در توسعه نرم‌افزارهای مالی و اتوماسیون بیمارستانی شناخته شویم.

 
  </p>

  </div>

</section>

<CardsInfo/>

{/* <CallDataFetch/> */}
{/* <CallDataAxios/> */}

</div>


    )

}






export default AboutUs;